import { render, staticRenderFns } from "./RetrievePassword.vue?vue&type=template&id=4183f2ac&scoped=true"
import script from "./RetrievePassword.vue?vue&type=script&lang=js"
export * from "./RetrievePassword.vue?vue&type=script&lang=js"
import style0 from "./RetrievePassword.vue?vue&type=style&index=0&id=4183f2ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4183f2ac",
  null
  
)

export default component.exports